import { IBaoCaoRequest } from "../../model/request/bao-cao/IBaoCaoRequest";
import { apiClient } from "../apiClient";
export const BAO_CAO_ENDPOINT = "bao-cao";

export const baoCaoApi = {
  Select: (request: IBaoCaoRequest) =>
    apiClient.post(`${BAO_CAO_ENDPOINT}/select-by-request`, request),

  ExportExcel: (request: IBaoCaoRequest) =>
    apiClient.post(`${BAO_CAO_ENDPOINT}/export-excel`, request),
};
